(function() { module.exports = this["wp"]["url"]; }());